import type { FaireProductEntity } from "../../entity_types/product";

export const p_44smk8tz6s: FaireProductEntity = {
  token: "p_44smk8tz6s",
  type: "product",
  name: "FLORAL PRINT SMOCKED SHORT SLEEVES MIDI DRESS",
  brandToken: "b_1taybicqc4",
  brandName: "BiBi",
  imageUrl:
    "https://cdn.faire.com/fastly/6faa36149fdf683d448c1cd3f43b0880b25b5e1f94758fce32beb1f3a0d0168e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48814885568fd78f932d6bb467e207728f84a051f979dcf5d16d0c4b4cd38edc.jpeg",
    "https://cdn.faire.com/fastly/0893f0f92f5046e5a65c50c32042a3caeca337bb7cea30a29c80d731483674ff.jpeg",
    "https://cdn.faire.com/fastly/73bc887cd43f664a9ac28dc361ab03fba3de6ef843e96e71a73bf737dcac7a8c.jpeg",
    "https://cdn.faire.com/fastly/258e8b0ec6318b8119f18eba828b928245237c3c6500d3d5f4e815da2261b5ed.jpeg",
    "https://cdn.faire.com/fastly/563e89735dedae37d3367f5f00569f5d9a11784da2ade0bbedaaffa7b0f3b372.jpeg",
    "https://cdn.faire.com/fastly/e7f1a5d560678120466867f9e3a14659f70f14f92c2260a81633a0bc40ad1601.jpeg",
    "https://cdn.faire.com/fastly/317eecbc9b7df6b0259df381575d2dda5982604508907f4dcf06324218281316.jpeg",
    "https://cdn.faire.com/fastly/a88fe2c7ae8b5628e966e13b937e7cd998ad8b2a26611ed2da444b66e062e574.jpeg",
    "https://cdn.faire.com/fastly/900431091ad6fd66296442b4a8bb583734352cd2d7cde5c40331a521de26a51b.jpeg",
  ],
  priceDollars: 226,
  description:
    "This floral print smocked short sleeves midi dress by BiBi is crafted with a 100% cotton self and a polyester-spandex lined interior. The smocked bodice and midi length of the dress add to its unique aesthetics. BiBi, a leader in women's clothing since 2018, brings this dress as part of its major collection of inspirational pieces.",
  tags: [],
  msrpDollars: 452,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:50.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
